// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".client-profile-div{display:flex;align-items:center;margin-left:2%}.client-profile-div .client-profile-link{margin-bottom:10%}", ""]);
// Exports
module.exports = exports;
